export default {
  navigationBarTitleText: intl.get('member.buyMember.memberCenter')
};
